import React from 'react';
import { assetPath } from '../assetPath';

// Shared Footer Component for public pages
const PublicFooter = ({ currentYear, t, socialLinks = {}, livechatEnabled = false }) => (
  <footer className="py-5" style={{ backgroundColor: '#111827' }}>
    <div className="container">
      <div className="row">
        {/* Brand Column */}
        <div className="col-lg-5 mb-4 mb-lg-0">
          <div className="d-flex align-items-center mb-3">
            <img
              src={assetPath('powerkid-icon.png')}
              alt="PowerKid Logo"
              className="me-2"
              style={{ width: '40px', height: '40px' }}
            />
            <span className="fw-bold text-white" style={{ fontSize: '24px' }}>
              PowerKid
            </span>
          </div>
          <p className="mb-4" style={{ color: '#9ca3af', maxWidth: '448px', lineHeight: '24px' }}>
            {t('landing.footer.brandDescription')}
          </p>
          {(socialLinks.facebook || socialLinks.youtube || socialLinks.tiktok) && (
            <div className="d-flex gap-3">
              {socialLinks.facebook && (
                <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" style={{ color: '#9ca3af' }} aria-label="Facebook">
                  <i className="bi bi-facebook" style={{ fontSize: '20px' }}></i>
                </a>
              )}
              {socialLinks.youtube && (
                <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" style={{ color: '#9ca3af' }} aria-label="YouTube">
                  <i className="bi bi-youtube" style={{ fontSize: '20px' }}></i>
                </a>
              )}
              {socialLinks.tiktok && (
                <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer" style={{ color: '#9ca3af' }} aria-label="TikTok">
                  <i className="bi bi-tiktok" style={{ fontSize: '20px' }}></i>
                </a>
              )}
            </div>
          )}
        </div>

        {/* Product Links */}
        <div className="col-sm-6 col-lg-3 mb-4 mb-lg-0">
          <h5 className="fw-semibold text-white mb-3">{t('landing.footer.product.title')}</h5>
          <ul className="list-unstyled">
            <li className="mb-2">
              <a href="/programs" className="text-decoration-none" style={{ color: '#9ca3af' }}>
                {t('landing.footer.product.programs')}
              </a>
            </li>
            <li className="mb-2">
              <a href="/features" className="text-decoration-none" style={{ color: '#9ca3af' }}>
                {t('landing.footer.product.features')}
              </a>
            </li>
            <li className="mb-2">
              <a href="/pricing" className="text-decoration-none" style={{ color: '#9ca3af' }}>
                {t('landing.footer.product.pricing')}
              </a>
            </li>
          </ul>
        </div>

        {/* Support Links */}
        <div className="col-sm-6 col-lg-3">
          <h5 className="fw-semibold text-white mb-3">{t('landing.footer.support.title')}</h5>
          <ul className="list-unstyled">
            {livechatEnabled && (
              <li className="mb-2">
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: '#9ca3af', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.LiveChatWidget) {
                      window.LiveChatWidget.call('maximize');
                    }
                  }}
                >
                  {t('landing.footer.support.contactUs')}
                </a>
              </li>
            )}
            <li className="mb-2">
              <a href="/privacy" className="text-decoration-none" style={{ color: '#9ca3af' }}>
                {t('landing.footer.support.privacyPolicy')}
              </a>
            </li>
            <li className="mb-2">
              <a href="/tos" className="text-decoration-none" style={{ color: '#9ca3af' }}>
                {t('landing.footer.support.termsOfService')}
              </a>
            </li>
            <li className="mb-2">
              <a href="/faq" className="text-decoration-none" style={{ color: '#9ca3af' }}>
                {t('landing.footer.support.faq')}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <hr className="my-4" style={{ borderColor: '#374151' }} />

      <div className="text-center" style={{ color: '#9ca3af' }}>
        <p className="mb-2">
          &copy; {currentYear} {t('landing.footer.copyright')}
        </p>
        <p className="mb-1" style={{ fontSize: '14px' }}>
          {t('landing.footer.company.name')}
        </p>
        <p className="mb-0" style={{ fontSize: '14px' }}>
          {t('landing.footer.company.address')}
        </p>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
